import * as React from 'react'
import { Route } from 'react-router-dom'
import { Configuration } from '../current-user/UserConfiguration'
import { DynamicStatisticsView } from '../stats/dynamic-statistics/DynamicStatisticsView'
import { PassageCountersView } from '../stats/passage-counters-view/PassageCountersView'
import { ResourceName } from '../../core/ResourceName'
import { TicketImport } from '../tickets/TicketImport'
import { ResetPasswordView } from './auth/ResetPasswordView'

export default [
  <Route exact path="/configuration" render={() => <Configuration />} />,
  <Route
    exact
    path="/stats-dynamic-statistics/:id/preview"
    render={({ ...routeProps }) => <DynamicStatisticsView {...routeProps} />}
  />,
  <Route
    exact
    path="/stats-passage-counters-view"
    render={() => <PassageCountersView />}
  />,
  <Route exact path="/reset-password" render={() => <ResetPasswordView />} />,
  <Route
    exact
    path="/password-expired"
    render={() => <ResetPasswordView passwordExpired />}
  />,
  <Route
    exact
    path={`/${ResourceName.TICKETS}/import`}
    render={({ ...routeProps }) => (
      <TicketImport
        {...routeProps}
        basePath={`/${ResourceName.TICKETS}`}
        resource={ResourceName.TICKETS}
      />
    )}
  />,
]
